import {
  ActionIcon,
  Box,
  Button,
  Container,
  Grid,
  Group,
  Indicator,
  Modal,
  Paper,
  SegmentedControl,
  SimpleGrid,
  Skeleton,
  Stack,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { connect, useDispatch } from "react-redux";
import "@mantine/charts/styles.css";
import { logger } from "utils/logger";
import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import { DateRanges, DateSelections, getClientLabel, getDateRanges } from "utils/helper";
import { EmptyState } from "core/components/emptyState/EmptyState";
import CaptureDetail from "core/components/capture/CaptureDetail";
import {
  fetchLatestStyles,
  fetchStylesByUnit,
  getStylesSuccess,
  setWipFilter,
} from "./homeSlice";
import { createColumnHelper } from "@tanstack/react-table";
import ImagePreview from "core/components/imagePreview/ImagePreview";
import HeatMap from "core/components/charts/HeatMap";
import { AreaChart, BarChart } from "@mantine/charts";
import classes from "./HomeModule.module.scss";
import { PrimaryBadge } from "core/components/badge/PrimaryBadge";

import DistributionList from "modules/Distributions/features/distributions/DistributionList";
import { fetchReport } from "modules/Wip/wipSlice";
import { AppConstants, getCompanyTableColumns } from "utils/constants";
import DateFilterControl from "core/components/dateFilterPanel/DateFilterControl";

// const formatDataForHeatmap = (items, dateKey = "distributionDate") => {
//   const contributionData = {};

//   items.forEach((item) => {
//     // For distributionDate format "2025-01-20-01-07-56-946"
//     // Or otbDate format "2025-01-06"
//     const date =
//       dateKey === "distributionDate"
//         ? item[dateKey].split("-").slice(0, 3).join("-") // Gets "2025-01-20"
//         : item[dateKey];

//     // Increment count for this date
//     contributionData[date] = (contributionData[date] || 0) + 1;
//   });

//   return contributionData;
// };

const getTotalsFromReport = (data, dateStart, dateEnd, key) => {
  // Convert date strings to Date objects for comparison
  const startDate = new Date(dateStart);
  const endDate = new Date(dateEnd);

  return data
    .filter((item) => {
      // Ensure the `periodDate` falls within the specified range
      const itemDate = new Date(item.periodDate || item.period.split("_")[1]);
      return itemDate >= startDate && itemDate <= endDate;
    })
    .reduce((total, item) => {
      // Sum up the values for the specified key
      const value = parseFloat(item[key]) || 0; // Ensure numeric values
      return total + value;
    }, 0); // Initialize the total as 0
};

const HomeModule = ({
  user,
  success,
  styles,
  wipFilter,
  setWipFilter,
  reportResultSet,
}) => {
  const theme = useMantineTheme();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const location = useLocation();
  const [heatMapView, setHeatMapView] = useState("year");
  // const heatmapData = formatDataForHeatmap(styles, "distributionDate");
  // const timelineData = getChartData(styles ?? [], "distributionDate", "Styles");
  const [timelineData, setTimelineData] = useState(
    getChartData(styles ?? [], "distributionDate", "Styles")
  );

  // const [dateFilterOpen, setDateFilterOpen] = useState(false);

  // const dateRange = wipFilter.dataFilter.dateRange.value;
  // const [searchParams, setSearchParams] = useSearchParams();
  const [fetchStatus, setFetchStatus] = useState(null);

  const [heatmapData, setHeatmapData] = useState([]);
  // const [timelineItems, setTimelineItems] = useState(["Styles", "Captures", "Assets"]);

  // const [currentYear, setCurrentYear] = useState(
  //   wipFilter?.dataFilter?.dateRange?.value?[0].getFullYear()
  // );
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());


  logger.log(reportResultSet.data, 'reportResultSet.data')
  const statData = useMemo(
    () => [
      {
        diff: 23,
        title: "Distributed Styles / Assets",
        value: `${styles?.length.toLocaleString()} / ${getTotalsFromReport(
          reportResultSet.data,
          wipFilter.dataFilter?.dateRange?.value[0],
          wipFilter.dataFilter?.dateRange?.value[1],
          "styleAssets"
        ).toLocaleString()}`,
        // value : getTotalsFromReport(reportResultSet.data, wipFilter.dataFilter?.dateRange?.value[0],  wipFilter.dataFilter?.dateRange?.value[1], 'styles'),
        color: theme.colors.blue[6],
      },
      {
        diff: -23,
        title: "Departments Distributed",
        value: getChartData(styles ?? [], "dept", "Styles").length,
        color: theme.colors.grape[6],
      },
      {
        diff: 23,
        title: "Products Scanned In",
        value: `${getTotalsFromReport(
          reportResultSet.data,
          wipFilter.dataFilter?.dateRange?.value[0],
          wipFilter.dataFilter?.dateRange?.value[1],
          "scansIn"
        )}`,
        color: theme.colors.pink[6],
      },
      {
        diff: 23,
        title: "Assets awaiting approval",
        value: 0,
        color: theme.colors.yellow[6],
      },
    ],
    [styles, theme, reportResultSet.data, wipFilter.dataFilter]
  );

  const [selectedItem, setSelectedItem] = useState([]);
  const [imageModalOpen, setImageModalOpen] = useState(false);

  const onCaptureChange = (type, data, items) => {};

  useEffect(() => {
    if (success) {
      logger.log("SAMPLE SUCCESS = ", success.type);
      switch (success.type) {
        case getStylesSuccess.toString(): {
          setIsLoading(false);
          const ids = styles.map((val) => val.styleNumber);
          dispatch(fetchLatestStyles(ids.slice(0, 5)));
          break;
        }
        default: {
          break;
        }
      }
    }
  }, [success, dispatch, styles]);

  useEffect(() => {
    const debouncedReportSearch = (criteria) => {
      const currentTime = Date.now();
      // Check if item exists and is not expired (e.g., 1 hour = 3600000 ms)
      if (
        reportResultSet.data &&
        currentTime - reportResultSet.timestamp < AppConstants.CACHE_DELAY_LONG
      ) {
        // return cachedItem.data;
        setIsLoading(false);
      } else {
        setIsLoading(true);
        dispatch(fetchReport(criteria));
      }
    };

    if (
      reportResultSet &&
      reportResultSet.data &&
      reportResultSet.data.length === 0
    ) {
      debouncedReportSearch();
    }
  }, [dispatch, reportResultSet]);

  useEffect(() => {
    var data = {};
    var timeline = [];
    var hmd;

    if (wipFilter?.dataFilter?.dateRange) {
      hmd = reportResultSet.data.map((val, idx) => {
        data[val.periodDate] = parseInt(val.styles);

        var weekstart = moment(wipFilter.dataFilter.dateRange.value[0]).format(
          "YYYY-MM-DD"
        );
        var weekend = moment(wipFilter.dataFilter.dateRange.value[1]).format(
          "YYYY-MM-DD"
        );
        if (val.periodDate >= weekstart && val.periodDate <= weekend) {
          const tmpDate = moment(
            val.periodDate,
            "YYYY-MM-DD-hh-mm-ss"
          ).toDate();
          var objKey = tmpDate.toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "2-digit",
          });
          timeline.push({
            Styles: parseInt(val.styles),
            distributionDate: objKey,
            Assets: parseInt(val.styleAssets),
            Captures: parseInt(val.captures),
          });
        }
        return val;
      });
    }

    if (hmd) {
      setHeatmapData(data);

      let mergedTimeline = mergeArrays(
        timeline,
        getChartData(styles ?? [], "distributionDate", "Styles")
      );

      // add asset count if not defined in the chart data.
      mergedTimeline = mergedTimeline.map((val) => {
        logger.log(val.Assets);
        if (!val.Assets) {
          return { ...val, Assets: 0, Styles: parseInt(val.Styles) };
        } else {
          return {
            ...val,
            Assets: parseInt(val.Assets),
            Styles: parseInt(val.Styles),
          };
        }
      });
      logger.log(mergedTimeline);
      setTimelineData(mergedTimeline);
    }

    // setTimelineData(getChartData(styles ?? [], "distributionDate", "Styles"))
  }, [reportResultSet.data, styles, wipFilter.dataFilter]);

  
  useEffect(() => {
    const debouncedSearch = (criteria) => {
      setIsLoading(true);
      dispatch(fetchStylesByUnit(criteria));
    };

    const params = new URLSearchParams(location.search);
    let weekstart = params.get("weekstart");

    // set it to this week
    if (!weekstart) {
      // check if we have a dateRange stored in the state if so we use that
      const filterDate = wipFilter.dataFilter?.dateRange?.value[0] ?? null;
      if (filterDate) {
        weekstart = moment(filterDate).format("YYYY-MM-DD");
      } else {
        const startDate = getDateRanges({
          value: DateRanges.THIS_WEEK,
        }).startDate;
        weekstart = moment(startDate).format("YYYY-MM-DD");
      }
    }
    const criteria = {
      status: "",
      //   weekStart: fetchStatus === FetchStatus.DISTRIBUTED ? weekstart : null,
      weekStart: weekstart,
    };

    debouncedSearch(criteria);

    // we only fetch when date changes
    // setDoFetch(false);
  }, [wipFilter.dataFilter, dispatch, location.search]);

  const mastersColumns = React.useMemo(
    () => {
      
      return [
      columnHelper.accessor("styleNumber", {
        header: "Style Number",
        cell: (info) => info.getValue(),
        size: 180,
      }),

      columnHelper.accessor("name", {
        header: "Name",
        cell: (info) => info.getValue(),
        size: 300,
      }),

      //   columnHelper.accessor("seasonCode", {
      //     header: "Event",
      //     cell: (info) => info.getValue(),
      //   }),

      //   columnHelper.accessor("sessionCode", {
      //     header: "Session",
      //     cell: (info) => info.getValue(),
      //   }),

      columnHelper.accessor("dept", {
        header: "Department",
        cell: (info) => info.getValue(),
        size: 180,
      }),
      columnHelper.accessor("otbDate", {
        header: user?.clientCode?`${getClientLabel(user?.clientCode, 'otbDate')}`:'OTB Date',
        cell: (info) => info.getValue(),
        size: 180,
      }),
      // columnHelper.accessor("completed", {
      //   header: "Completed",
      //   cell: (info) => info.getValue(),
      // }),

      columnHelper.accessor("distributionDate", {
        header: "Distribution Date",
        cell: (info) => info.getValue(),
        size: 200,
      }),
    ]},
    []
  );


  const onRowClick = (event, type) => {
    switch (type) {
      case "season": {
        navigate(`/seasons/${event.seasonPart}`);
        break;
      }

      case "session": {
        navigate(`/sessions/${event.ssPart}`);
        break;
      }
      default: {
        break;
      }
    }
  };

  /**
   * Effect to handle location change
   */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let displayType = params.get("displayType");

    // set the fetch status so we know what to pass to the criteria
    const status = params.get("status");
    const weekstart = params.get("weekstart");

    if (fetchStatus !== status) {
      setFetchStatus(status);
    }

    if (weekstart) {
      // add seven days onto the date.
      var startDate = new Date(weekstart);
      startDate.setHours(0, 0, 0, 0);

      var endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 7);
      endDate.setHours(23, 59, 59, 999);

      // if it's past the current date set it today
      const today = getDateRanges({ value: DateRanges.TODAY });
      if (endDate > today.endDate) {
        endDate = today.endDate;
      }

      if (startDate > today.startDate) {
        startDate = today.startDate;
      }
      var item;

      // check if the date is one of the predefined values
      switch (startDate.toDateString()) {
        case getDateRanges({
          value: DateRanges.TODAY,
        }).startDate.toDateString(): {
          item = DateSelections[0];
          break;
        }
        case getDateRanges({
          value: DateRanges.THIS_WEEK,
        }).startDate.toDateString(): {
          item = DateSelections[1];
          break;
        }
        case getDateRanges({
          value: DateRanges.LAST_WEEK,
        }).startDate.toDateString(): {
          item = DateSelections[2];
          break;
        }
        default: {
          item = DateSelections[3];
          break;
        }
      }

      const dataFilter = {
        ...wipFilter.dataFilter,
        dateRange: {
          item: item,
          value: [startDate, endDate],
        },
      };

      // Only update state if it has changed
      if (
        JSON.stringify(dataFilter) !== JSON.stringify(wipFilter.dataFilter)
      ) {
        setWipFilter({ ...wipFilter, dataFilter: dataFilter });
      }
    }

    logger.log("location change ", location, " DISPLAY: ", displayType, params);
  }, [location, fetchStatus, setWipFilter, wipFilter]);

  const onImageClick = (val) => {
    logger.log(val);
    setSelectedItem(val);
    setImageModalOpen(true);
  };

  const departmentData = getChartData(styles ?? [], "dept", "Styles");
  const latestStyles = styles.slice(0, 10);


  const totalCount = Object.values(heatmapData).reduce((sum, count) => sum + count, 0);
/**
 * Calculates the total count by year or month from date-based data
 * @param {Object} data - Object with dates as keys and counts as values
 * @param {string} groupBy - Either 'year' or 'month'
 * @returns {Object} - Aggregated totals by year or month
 */
function getTotalCountBy(data, groupBy) {
  // Validate input
  if (!['year', 'month'].includes(groupBy)) {
    throw new Error("groupBy parameter must be either 'year' or 'month'");
  }
  
  const result = {};
  
  for (const [dateStr, count] of Object.entries(data)) {
    // Extract date parts
    const date = new Date(dateStr);
    const year = date.getFullYear();
    
    if (groupBy === 'year') {
      // Group by year
      if (!result[year]) {
        result[year] = 0;
      }
      result[year] += count;
    } else {
      // Group by month
      // Format as YYYY-MM
      const month = date.getMonth() + 1; // getMonth() returns 0-11
      const yearMonth = `${year}-${month.toString().padStart(2, '0')}`;
      
      if (!result[yearMonth]) {
        result[yearMonth] = 0;
      }
      result[yearMonth] += count;
    }
  }
  
  return result;
}

// Example usage:
// const yearlyTotals = getTotalCountBy(data, 'year');
// const monthlyTotals = getTotalCountBy(data, 'month');

// const columns = getCompanyTableColumns(user.clientCode, "masters");

  return (
    <Container px={"lg"} fluid sx={{ marginLeft: 0 }} pt={"lg"}>
      <Group>
        <Group mb={"md"} justify="space-between" style={{ width: "100%" }}>
          <Title order={2}>Welcome back, {user?.first} 👋</Title>
          <DateFilterControl filter={wipFilter} onApply={(dateStart) => {}} />
          {/* <Group grow={true} className={classes.dateFilter} style={{flexGrow:mobileMatch?1:0}}>
            <Popover
              shadow="sm"
              opened={dateFilterOpen}
              onClose={() => setDateFilterOpen(false)}
              width={tabletMatch?'100%':480}
              position="bottom"
              withArrow
              closeOnClickOutside={true}
              onChange={setDateFilterOpen}
            >
              <Popover.Target>
                <div style={{width:'100%'}}>
                  <Button fullWidth
                    variant="light"
                    onClick={() => setDateFilterOpen((o) => !o)}
                    px={"xs"}
                  >
                    <Group>
                      <Badge color="green" variant="light">
                        {wipFilter.dataFilter.dateRange.item.label}
                      </Badge>
                      <Text size={"sm"} truncate style={{maxWidth:mobileMatch?100:'100%'}}>
                        <Moment format="D MMM YYYY">{dateRange[0]}</Moment> -{" "}
                        <Moment format="D MMM YYYY">{dateRange[1]}</Moment>
                      </Text>
                      <IconChevronDown size={14} />
                    </Group>
                  </Button>
                </div>
              </Popover.Target>
              <Popover.Dropdown>
                <div style={{ display: "flex" }}>
                  <DateFilterPanel
                    showTimePicker={false}
                    filter={wipFilter.dataFilter}
                    onCancel={() => setDateFilterOpen(false)}
                    onApply={(vals) => {
                      let urlParms = Object.fromEntries([...searchParams]);
                      // const urlParms = new URLSearchParams(window.location.search);
                      var startDate = vals.dateRange.value[0];
                      startDate.setHours(0, 0, 0, 0);

                      // if it's past the current date set it today
                      const today = getDateRanges({
                        value: DateRanges.TODAY,
                      });
                      if (startDate > today.startDate) {
                        startDate = today.startDate;
                      }

                      const formattedDate =
                        moment(startDate).format("YYYY-MM-DD");

                      // set the settings as part of the url.
                      searchParams.set("weekstart", formattedDate);
                      urlParms.weekstart = formattedDate;
                      setSearchParams(urlParms);

                      setDateFilterOpen(false);
                      // setDoFetch(true);
                    }}
                  />
                </div>
              </Popover.Dropdown>
            </Popover>
          </Group> */}
        </Group>
      </Group>

      <StatsGridIcons
        isLoading={isLoading}
        data={statData}
        onStatClick={() => {}}
      />

      <Grid>
        <Grid.Col span={{ base: 12, md: 8, lg: 9 }}>
          <Paper my={"md"} p="lg" withBorder>
            <Group justify="space-between">
              <Title order={4} mb="lg">
                Timeline
              </Title>

              {/* <MultiSelect
                value={timelineItems} 
                onChange={(val) => setTimelineItems([...val])}                 
                
                w={300}
                data={['Styles', 'Assets', 'Captures']}
              /> */}
            </Group>
            <AreaChart
              h={300}
              data={timelineData}
              dataKey="distributionDate"
              curveType="linear"
              connectNulls
              // legendProps={{ verticalAlign: 'bottom', height: 50 }}

              // type="stacked"
              withGradient
              withLegend
              series={[
                { name: "Styles", color: "blue.6" },
                { name: "Assets", color: "violet.6" },
                // { name: "Captures", color: "teal.6" },
              ]}
            />
          </Paper>

          <Box align="start">
            <Box style={{}}>
              <Paper p={"lg"} withBorder>
                <Group justify="space-between" mb={"md"} align="center">
                  <Group>
                    <Title order={4}>Distributions</Title>
                    <PrimaryBadge>{getTotalCountBy(heatmapData,'year')[currentYear]}</PrimaryBadge>
                  </Group>

                  <Group justify="center">
                    <ActionIcon
                      size={"sm"}
                      variant="default"
                      onClick={() => setCurrentYear(currentYear - 1)}
                    >
                      <IconChevronLeft />
                    </ActionIcon>
                    <Text size="sm">Year {currentYear}</Text>
                    <ActionIcon
                      size={"sm"}
                      variant="default"
                      onClick={() => setCurrentYear(currentYear + 1)}
                    >
                      <IconChevronRight />
                    </ActionIcon>
                  </Group>

                  <SegmentedControl
                    value={heatMapView}
                    onChange={setHeatMapView}
                    data={[
                      { label: "Year", value: "year" },
                      { label: "Month", value: "month" },
                    ]}
                  />
                </Group>

                <HeatMap
                  data={heatmapData}
                  view={heatMapView}
                  startDate={moment(
                    wipFilter.dataFilter?.dateRange?.value[0]
                  ).toDate()}
                  currentYear={currentYear}
                />
              </Paper>

              <Paper my={"md"} p={"lg"} withBorder>
                <Group mb={"md"} justify="space-between">
                  <Group>
                    <Title order={4}>Latest Distributions</Title>
                    <PrimaryBadge>{latestStyles?.length}</PrimaryBadge>
                  </Group>
                  <Button variant="default" onClick={() => navigate("/wip")}>
                    Show All
                  </Button>
                </Group>
                <div className="table-wrapper">
                  <CustomTable
                    onItemClick={(event) => onRowClick(event, "master")}
                    isLoading={isLoading}
                    selectedItems={[]}
                    columns={mastersColumns}
                    data={styles ?? []}
                    user={user}
                  />
                </div>
              </Paper>
            </Box>
          </Box>
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 4, lg: 3 }}>
          <Stack mt={"md"} gap={"md"}>
            <Paper p={"lg"} withBorder>
              <Title order={4} mb={"md"}>
                Monthly Distributions
              </Title>

              {wipFilter?.dataFilter ? (
                <HeatMap
                  data={heatmapData}
                  view={"month"}
                  startDate={moment(
                    wipFilter?.dataFilter?.dateRange?.value[0]
                  ).toDate()}
                  currentYear={moment(
                    wipFilter?.dataFilter?.dateRange?.value[0]
                  )
                    .toDate()
                    .getFullYear()}
                />
              ) : null}
            </Paper>

            <Paper p="lg" withBorder>
              <Group mb={"md"}>
                <Title order={4}>Distributions by Department</Title>
                <PrimaryBadge>{departmentData?.length}</PrimaryBadge>
              </Group>

              {/* <RadarChart
              h={300}
              data={departmentData}
              dataKey="dept"
              withPolarRadiusAxis
              series={[{ name: "Styles", color: "blue.4", opacity: 0.2 }]}
            /> */}

              <BarChart
                h={300}
                data={departmentData.map((val) => ({
                  ...val,
                  value: val.Styles,
                  color: "blue.4",
                  name: val.dept,
                }))}
                dataKey="dept"
                withLegend
                // labelsType="value"
                withTooltip
                // orientation="vertical"
                series={[
                  { name: "Styles", color: "blue.6" },
                  // { name: "Oranges", color: "blue.6" },
                  // { name: "Tomatoes", color: "teal.6" },
                ]}
              />
            </Paper>

            <Paper p={"lg"} withBorder>
              <Group mb={"md"}>
                <Title order={4}>Latest Assets</Title>
                <PrimaryBadge>
                  {
                    latestStyles?.flatMap((item) => item.assets).slice(0, 8)
                      .length
                  }
                </PrimaryBadge>
              </Group>

              <Box>
                <Group
                  gap={0}
                  wrap="wrap"
                  justify="center"
                  mr={"-md" / 2}
                  ml={"-md" / 2}
                >
                  {latestStyles
                    ?.flatMap((item) => {
                      return item.assets?.map((val) => ({
                        ...val,
                        name: `${item.styleNumber} - ${item.name}`,
                      }));
                    })
                    .slice(0, 8)
                    .map((val, idx) => {
                      return (
                        <div className={classes.assetRenderer} key={idx}>
                          {val ? (
                            <ImagePreview
                              file={{ url: val?.thumb }}
                              onClick={() => onImageClick(val)}
                              height={"100%"}
                              width={"auto"}
                            />
                          ) : (
                            //   <ImagePreview
                            //     shot={{ ...val, ...selectedItem }}
                            //     size={100}
                            //     src={imageURL}
                            //     tags={val.tags}
                            //     fit="contain"
                            //     showMetaInfo={false}
                            //   />
                            <div></div>
                          )}
                        </div>
                      );
                    })}
                </Group>

                {!selectedItem ||
                (selectedItem && selectedItem.assets?.length === 0) ? (
                  <EmptyState
                    caption="There are no assets"
                    style={{ height: 200 }}
                  />
                ) : null}
                {/* <TalentList data={[{avatar:selectedItem.filePath,name:'Test User'}]}/> */}
              </Box>
            </Paper>
          </Stack>
        </Grid.Col>
      </Grid>

      <Modal
        opened={imageModalOpen}
        size={"lg"}
        title={selectedItem.name}
        trapFocus={true}
        fullScreen
        onClose={() => setImageModalOpen(false)}
      >
        <CaptureDetail
          showSettings={false}
          resoloveImage={true}
          image={selectedItem}
          src={selectedItem.preview}
          onImageEvent={() => logger.log("On image event")}
          onCaptureChange={onCaptureChange}
        />
      </Modal>
    </Container>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    wipFilter: state.homeReducer.wipFilter,
    styles: state.homeReducer.styles,
    // style: state.styleReducer.selectedStyle,
    success: state.homeReducer.success,
    error: state.auth.error,
    reportResultSet: state.wipReducer.report,
    // guides: state.guideReducer.guides,
  };
};

const mapDispatch = { setWipFilter };

export default connect(mapStateToProps, mapDispatch)(HomeModule);

export function StatsGridIcons({ data, onStatClick, isLoading }) {
  // const { classes } = useStyles();
  const stats = data.map((stat) => {
    // const DiffIcon = stat.diff > 0 ? IconArrowUpRight : IconArrowDownRight;
    return (
      <Paper
        shadow="md"
        className={classes.statPanel}
        withBorder
        p="md"
        radius="md"
        key={stat.title}
        onClick={() => onStatClick(stat)}
      >
        <Group position="apart">
          <div>
            <Indicator zIndex={2} position="middle-start" color={stat.color}>
              <Text
                style={{ paddingLeft: 12 }}
                c="dimmed"
                tt="uppercase"
                fw={700}
                size="xs"
                className={classes.label}
              >
                {stat.title}
              </Text>
            </Indicator>

            {isLoading ? (
              <Skeleton h={21} mt="sm" />
            ) : (
              <Text fw={700} size="xl">
                {stat.value}
              </Text>
            )}
          </div>
          {/* <ThemeIcon color='gray' variant='light' sx={(theme) => ({ color: stat.diff > 0 ? theme.colors.teal[6] : theme.colors.red[6] })} size={38} radius='md'>
                        <DiffIcon size={28} stroke={1.5} />
                    </ThemeIcon> */}
        </Group>
      </Paper>
    );
  });

  return (
    <div className={classes.root}>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }}>{stats}</SimpleGrid>
    </div>
  );
}

const CustomTable = ({
  columns,
  data,
  selectedItems,
  onItemClick,
  onItemSelected,
  isLoading,
  onMenuClick,
  user,
}) => {
  // Render the UI for your table
  return (
    <>
      {data.length ? (
        <DistributionList
          user={user}
          loading={false}
          data={data.slice(0, 10)}
          onItemClick={() => {}}
          columns={columns}
          selectedItems={[]}
          showPagination={false}
        />
      ) : null}

      {!isLoading && data.length === 0 ? (
        <EmptyState showImage={false} style={{ padding: 20 }} />
      ) : null}
    </>
  );
};

const getChartData = (data, groupBy, key) => {
  return Object.values(
    data.reduce((acc, item) => {
      let objKey = item[groupBy];

      // Grouping logic based on `groupBy`
      switch (groupBy) {
        case "distributionDate": {
          const tmpDate = moment(item[groupBy], "YYYY-MM-DD-hh-mm-ss").toDate();
          objKey = tmpDate.toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "2-digit",
          });

          // Initialize if this key doesn't exist in acc
          if (!acc[objKey]) {
            acc[objKey] = {
              [groupBy]: objKey,
              [key]: 0,
            };
          }

          break;
        }

        // case "dept": {

        //   if()
        //   objKey = item[key]
        //   // Initialize if this key doesn't exist in acc
        //   if (!acc[objKey]) {
        //     acc[objKey] = {
        //       [groupBy]: objKey,
        //       [key]: 0,
        //     };
        //   }

        //   break;
        // }

        default:
          if (!acc[objKey]) {
            acc[objKey] = {
              [groupBy]: objKey,
              [key]: 0,
            };
          }
          break;
      }

      // Increment the count for the given key
      if (objKey) {
        acc[objKey][key] += 1;
      }
      return acc;
    }, {})
  );
};

const columnHelper = createColumnHelper();

function mergeArrays(array1, array2) {
  // Create a map from the second array using date as key
  const dateMap = new Map(array2.map((item) => [item.distributionDate, item]));

  // Create a Set of all unique dates
  const allDates = new Set([
    ...array1.map((item) => item.distributionDate),
    ...array2.map((item) => item.distributionDate),
  ]);

  // Convert dates to array and sort them
  const sortedDates = [...allDates].sort((a, b) => new Date(a) - new Date(b));

  // Create the resulting array
  const result = sortedDates.map((date) => {
    const array1Item = array1.find((item) => item.distributionDate === date);
    const array2Item = dateMap.get(date);

    if (array1Item && array2Item) {
      // If date exists in both arrays, update the Styles
      return {
        ...array1Item,
        Styles: array2Item.Styles.toString(),
      };
    } else if (array1Item) {
      // If date only exists in array1, keep it as is
      return array1Item;
    } else {
      // If date only exists in array2, create new object with default values
      return {
        Styles: array2Item.Styles.toString(),
        distributionDate: date,
        Assets: "0",
      };
    }
  });

  return result;
}
